import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CreditRequirements } from '../../../../ng2/shared/constants/credit-requirements.constant';
import { CurrentSchoolYear } from '../../../../ng2/shared/constants/current-school-year.constant';

angular.module('nv.shared.modals').controller('CreditGapModalCtrl', CreditGapModalCtrl);

function CreditGapModalCtrl(
  school,
  student,
  activeMode,
  gapPlan,
  creditReq,
  courseCode,
  $mdDialog,
  $scope,
  ErrorModal,
  $window,
  SDCStore,
  sdcActions,
  UtilitiesService,
  ImSchool: ImSchool,
) {
  const omitted = ['HPE', 'ELA_OTHER', 'SCI_OTHER', 'SCI_CORE', 'SS_ELECTIVE', 'MISC'];

  this.creditRequirements = angular.copy(CreditRequirements);
  this.creditRequirements.TOTAL.human = 'Total (44 Req)';
  this.gapPlan = gapPlan;
  this.school = school;
  this.student = student;

  // set studentMini data on gapPlan
  this.gapPlan.student.studentId = student._id;
  this.gapPlan.student.lastFirst = student.studentDetails.name.lastFirst;

  this.termDisabled = false;
  this.schoolCodeDeck = ImSchool.getSchoolCodeDeck(this.school);
  this.CreditReqAreas = _.sortBy(_.omit(this.creditRequirements, omitted), (req: any) => req.orders.creditGapModal);
  // ASSIGN_MODE: TODO: Return an array of credReq strings

  // TODO: (DS) This can probably be simplified now that gradReq is a property on the codeDeck
  this.getCoursesByCredReq = selectedCreditArea => {
    const creditReqData: any = _.find(this.creditRequirements, { camelCase: selectedCreditArea });
    const courseDropdown = [
      { courseCode: 'Not a gap - coding issue', creditValue: null, gradReq: null, subjectArea: null },
    ];

    if (!this.schoolCodeDeck[selectedCreditArea] && creditReqData) {
      _.each(creditReqData.join, courseCode => {
        const schoolCodeDeckCourseCode: any = _.find(this.schoolCodeDeck, (v, k: any) => k === courseCode);

        if (schoolCodeDeckCourseCode) {
          courseDropdown.push(schoolCodeDeckCourseCode);
        }
      });
      return _.flatten(courseDropdown);
    } else {
      return _.union(courseDropdown, this.schoolCodeDeck[selectedCreditArea]);
    }
  };

  // Populates edit modal info, not on gapPlan model
  this.convertCredReqToHuman = () => {
    const gradReq: any = _.find(this.CreditReqAreas, { camelCase: this.gapPlan.gradReq });
    if (gradReq) {
      return gradReq.human;
    }
  };

  // ASSIGN_MODE: Used to know after how many terms year++: This excludes summer
  const TERM_INFO = {
    ANNUALIZED: { termsPerYear: 1, newCalenderAfter: 1 },
    SEMESTER: { termsPerYear: 2, newCalenderAfter: 1 },
    TRIMESTER: { termsPerYear: 3, newCalenderAfter: 2 },
    QUARTERLY: { termsPerYear: 4, newCalenderAfter: 2 },
  };

  // ASSIGN_MODE: Create term dropdown : returns {}<Array> w name/code keys:
  this.populateTermDropDown = termInfo => {
    let currentYearStart = Number(CurrentSchoolYear.START);
    let currentTerm = ImSchool.getCurrentTermNumber(this.school);
    const currentTermYear = ImSchool.getCurrentTermYear(this.school);
    const schoolTermsPerYear = ImSchool.getNumTermsPerYear(this.school);
    const dropDown = [];
    const termStructure: any = angular.copy(_.find(termInfo, { termsPerYear: schoolTermsPerYear }));

    const firstTermData = {
      termName: UtilitiesService.getHumanReadableTerm(currentTermYear),
      termCode: currentTermYear,
    };
    dropDown.push(firstTermData);

    // Populate dropdown of ~30 terms including current term:
    _.times(30, () => {
      const termData: any = {};
      if (currentTerm < termStructure.newCalenderAfter) {
        currentTerm += 1;
        let termCode = currentYearStart.toString() + currentTerm;
        termData.termName = UtilitiesService.getHumanReadableTerm(+termCode);
        termData.termCode = +termCode;
        dropDown.push(termData);
      } else if (currentTerm >= termStructure.newCalenderAfter && currentTerm < termStructure.termsPerYear) {
        let termCode = currentYearStart.toString() + (currentTerm + 1);
        termData.termName = UtilitiesService.getHumanReadableTerm(+termCode);
        termData.termCode = +termCode;
        dropDown.push(termData);
        currentTerm += 1;
      } else {
        let termCode = currentYearStart.toString() + 7;
        currentTerm = 0;
        currentYearStart += 1;
        termData.termName = UtilitiesService.getHumanReadableTerm(+termCode);
        termData.termCode = +termCode;
        dropDown.push(termData);
      }
    });
    return dropDown;
  };

  // ASSIGN_MODE: Find proper index to slice array for student/school:
  this.calculateGradTermCodePlusOne = () => {
    let gradTermYear;
    const lastPossibleTerm = ImSchool.getNumTermsPerYear(this.school).toString(); // remove summer
    const schoolsCurrentTermCode = ImSchool.getCurrentTermYear(this.school).toString();
    // Account for classOf being nullable:
    if (this.student.studentDetails.classOf) {
      // Account for `super seniors`:
      const studentsLastTermYear = Number(this.student.studentDetails.classOf.slice(2)) - 1;
      const studentsLastTermCode = studentsLastTermYear + lastPossibleTerm;
      if (studentsLastTermCode < schoolsCurrentTermCode) {
        gradTermYear =
          Number(
            ImSchool.getCurrentTermYear(this.school)
              .toString()
              .slice(0, 2),
          ) + 1;
      } else {
        gradTermYear = Number(this.student.studentDetails.classOf.slice(2));
      }
    } else {
      gradTermYear =
        Number(
          ImSchool.getCurrentTermYear(this.school)
            .toString()
            .slice(0, 2),
        ) + 1;
    }
    return Number(gradTermYear + lastPossibleTerm);
  };

  // ASSIGN_MODE: Trim term dropdown to disallow assigning after plan after expected graduation
  this.trimDropdown = (trimFn, dropdownFn) => {
    const gradLimit = trimFn();
    const termOptions = dropdownFn(TERM_INFO);
    const dropdownLimitIndex = _.findIndex(termOptions, (term: any) => {
      return term.termCode === gradLimit;
    });
    const trimmedDropdown = termOptions.slice(0, dropdownLimitIndex + 2); // include summer
    trimmedDropdown.push({ termName: 'N/A', termCode: 999 });
    return trimmedDropdown;
  };

  // Terms<Array>:
  this.termDropdown = this.trimDropdown(this.calculateGradTermCodePlusOne, this.populateTermDropDown);

  // ASSIGN_MODE: fired on match/selection:
  this.setCourseDetails = course => {
    if (course) {
      if (course.courseCode !== 'Not a gap - coding issue') {
        this.gapPlan.creditValue = Number(course.creditValue);
        this.gapPlan.plan = course.courseCode;
        this.gapPlan.termYear = this.gapPlan.termYear ? this.gapPlan.termYear : this.termDropdown[1].termCode;
      } else if (course.courseCode === 'Not a gap - coding issue') {
        this.termDisabled = true;
        this.gapPlan.creditValue = null;
        this.gapPlan.plan = course.courseCode;
        let year: any = _.last(this.termDropdown);
        this.gapPlan.termYear = year.termCode;
      }
    }
  };

  // ASSIGN_MODE: Set text on model: called on keyDown in autocomplete
  this.createCustomCourse = courseInput => {
    this.termDisabled = false;
    this.gapPlan.termYear = this.gapPlan.termYear ? this.gapPlan.termYear : this.termDropdown[1].termCode;
    this.gapPlan.plan = courseInput;
  };

  if (creditReq) {
    this.gapPlan.gradReq = creditReq;
  }

  if (courseCode) {
    this.gapPlan.plan = courseCode;
  }

  // BOTH:
  this.searchText = this.gapPlan.plan || '';

  // Autocomplete query:
  this.queryCourseCodes = searchText => {
    const coursesByCredReq = this.getCoursesByCredReq(this.gapPlan.gradReq);
    const filteredCourses = _.filter(coursesByCredReq, (course: any) => {
      return _.includes(course.courseCode.toLowerCase(), searchText.toLowerCase());
    });
    return this.searchText ? filteredCourses : coursesByCredReq;
  };

  // BOTH: clear fields on new creditReq selection:
  this.resetModalFields = () => {
    this.searchText = courseCode || '';
    this.gapPlan.plan = courseCode || null;
    this.gapPlan.creditValue = null;
  };

  // EDIT_MODE: convert to readable name:
  this.convertTermCodeToHuman = () => {
    const termYear = this.gapPlan.termYear;
    if (termYear === 999) {
      return 'N/A';
    }
    return UtilitiesService.getHumanReadableTerm(termYear);
  };

  // BOTH: Cancel btn
  this.closeModal = () => {
    $mdDialog.hide();
  };

  this.createGapPlan = () => {
    const storedStudentsLength = SDCStore.getAllStudents().length;

    this.gapPlan
      .$create()
      .then(() => {
        if (storedStudentsLength) {
          sdcActions.addGapPlan(this.gapPlan);
        }
      })
      .catch(error => {
        ErrorModal.show('Error', error);
      });

    $mdDialog.hide({
      action: 'ADD_GAP_PLAN',
      gapPlan: this.gapPlan,
    });
  };

  this.updateGapPlan = () => {
    const storedStudentsLength = SDCStore.getAllStudents().length;

    const fields = ['_id', 'gradReq', 'plan', 'termYear', 'creditValue', 'note'];

    this.gapPlan
      .$patchFields(fields)
      .then(() => {
        if (storedStudentsLength) {
          sdcActions.updateGapPlan(this.gapPlan);
        }
      })
      .catch(error => {
        ErrorModal.show('Error', error);
      });

    $mdDialog.hide({
      action: 'UPDATE_GAP_PLAN',
      gapPlan: this.gapPlan,
    });
  };

  // ASSIGN_MODE:
  this.validateAssignModalFields = () => {
    return _.every(_.omit(this.gapPlan, 'note'), v => {
      return v;
    });
  };

  this.validateEditModalFields = () => {
    return _.every(_.pick(this.gapPlan, ['gradReq', 'plan', 'creditValue', 'termYear']), v => {
      return v;
    });
  };
}
